import { i18n } from 'src/i18n';
import exporterRenders from 'src/modules/shared/exporter/exporterRenders';

export default [
  {
    name: 'id',
    label: i18n('entities.categoriaProducto.fields.id'),
  },
  {
    name: 'nombre',
    label: i18n('entities.categoriaProducto.fields.nombre'),
  },
  {
    name: 'codigo',
    label: i18n('entities.categoriaProducto.fields.codigo'),
  },
  {
    name: 'createdAt',
    label: i18n('entities.categoriaProducto.fields.createdAt'),
    render: exporterRenders.datetime(),
  },
  {
    name: 'updatedAt',
    label: i18n('entities.categoriaProducto.fields.updatedAt'),
    render: exporterRenders.datetime(),
  },
];
